const singletonId = Symbol();
const singletonEnforcer = Symbol();

class SingletonGlobalEvents {
  constructor(enforcer) {
    if (enforcer !== singletonEnforcer) throw new Error('SingletonGlobalEvents can not use construct.');

    const _ = this;

    _.globalEvents = {};
  }

  static getInstance() {
    if (!this[singletonId]) this[singletonId] = new SingletonGlobalEvents(singletonEnforcer);
    return this[singletonId];
  }

  addCallback(globalEventName, func) {
    const _ = this;

    let callbacks = _.globalEvents[globalEventName];

    if (callbacks === null || typeof callbacks === 'undefined') {
      _.globalEvents[globalEventName] = [func];

      $(window).on(`${globalEventName}.singletonglobalevents`, (evt) => {
        _.globalEvents[globalEventName].forEach((element, index, array) => element(evt));
      });

    } else {
      if (callbacks.indexOf(func) < 0) callbacks.push(func);
    }
  }

  removeCallback(globalEventName, func) {
    const _ = this;

    let callbacks = _.globalEvents[globalEventName];

    if (callbacks) {
      const callbackIndex = callbacks.indexOf(func);
      callbacks.splice(callbackIndex, 1);

      if (callbacks.length <= 0) {
        $(window).off(`${globalEventName}.singletonglobalevents`);

        _.globalEvents[globalEventName] = null;
      }
    }
  }
}

export default SingletonGlobalEvents;



// WEBPACK FOOTER //
// ./_src/js/utils/SingletonGlobalEvents.js